import { spacingFluidMd, spacingFluidXl } from "@porsche-design-system/components-react/emotion"
import type { VisibilityView } from "@slfinrtl/ui-bff-routes"
import { defineMessages, useIntl } from "react-intl"
import { Grid, GridItem, List, OnlineOrderingIcon, VisibilityStatus } from "src/components"

const messages = defineMessages({
	onlineOrderingLabel: {
		defaultMessage: "Online Orderable",
		id: "vehicleDetails.overview.listing.onlineOrdering",
	},
	visibility: {
		defaultMessage: "Visibility",
		id: "vehicleDetails.overview.listing.visibility",
	},
})

interface VisibilityProps {
	isOnlineOrderingEnabled: boolean
	view: VisibilityView
}

export const Visibility = ({ isOnlineOrderingEnabled, view }: VisibilityProps) => {
	const { formatMessage } = useIntl()
	return (
		<Grid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }}>
			<GridItem size={{ base: 12, m: 6 }}>
				<List>
					<List.Item
						label={formatMessage(messages.visibility)}
						value={<VisibilityStatus weight="semibold" view={view.visibility} />}
					/>
					{isOnlineOrderingEnabled && (
						<List.Item
							label={formatMessage(messages.onlineOrderingLabel)}
							value={<OnlineOrderingIcon weight="semibold" view={view.onlineOrdering} />}
						/>
					)}
				</List>
			</GridItem>
		</Grid>
	)
}
